import dashboardApi from 'services/api/dashboard'

export const getBlacklistAnalyze = (exclusions, convertedSubscriberHotelBookingId) => {
  return async dispatch => {
    dispatch({
      type: 'GET_BLACKLIST_ANALYZE_STARTED'
    })

    try {
      const response = await dashboardApi.postAnalyze({
        convertedSubscriberHotelBookingId,
        exclusions
      })
      dispatch(gotBlacklistAnalyze(response))
    } catch (err) {
      console.warn({ err })
      dispatch({
        type: 'GET_BLACKLIST_ANALYZE_FAILED',
        payload: err
      })
    }
  }
}

export const gotBlacklistAnalyze = analyzeResults => ({
  type: 'GOT_BLACKLIST_ANALYZE',
  payload: analyzeResults
})

export const cleanBlacklistAnalyze = () => ({
  type: 'CLEAN_BLACKLIST_ANALYZE'
})

// add blacklist
//
export const postBlacklist = (exclusions, convertedSubscriberHotelBookingId) => {
  return async dispatch => {
    dispatch({
      type: 'POST_BLACKLIST_STARTED'
    })

    try {
      const response = await dashboardApi.postBlacklist({
        convertedSubscriberHotelBookingId,
        exclusions
      })
      dispatch(postedBlacklist(response))
    } catch (err) {
      console.warn({ err })
      dispatch({
        type: 'POST_BLACKLIST_FAILED',
        payload: err
      })
    }
  }
}

export const postedBlacklist = () => ({
  type: 'POSTED_BLACKLIST'
})

export const cleanPostedBlacklist = () => ({
  type: 'CLEAN_POSTED_BLACKLIST'
})
